module.exports = __webpack_public_path__ + "img/b171b11.png";